import { Link } from '@mui/material'
import type { LinkProps, TypographyProps } from '@mui/material'

export const ButtonLink = (props: LinkProps & Pick<TypographyProps, 'variant'>) => (
  <Link component="button" {...props} />
)

export default ButtonLink
